
/*******************************************************************************
** Start of Content Intro(overview) & Content Intro (Testing) functionality
*******************************************************************************/
// Video Play Pause script
$ = jQuery;
let additionalVideoPlayBtn = document.querySelectorAll(".video-container .pause-play-btn");
if (additionalVideoPlayBtn.length) {
  additionalVideoPlayBtn.forEach(function (playBtn) {
    playBtn.addEventListener("click", function (e) {
      let videoElement = this.closest('.video-container').querySelector(".bg-loop-video");
      if (videoElement.paused) {
        videoElement.play();
        this.classList.add('pause-icon');
        this.classList.remove('play-icon');
      } else {
        videoElement.pause();
        this.classList.add('play-icon');
        this.classList.remove('pause-icon');
      }
    })
  })
}

let additionalServices = document.querySelector(".ge9x-content-intro");
if (additionalServices) {
  $(window).on("scroll", function () {
    $(".ge9x-content-intro .bg-scroll-video").each(function () {
      let scrollTopPosition = $(window).scrollTop();
      let paraTop = $(".bg-img").offset().top;
      let topPosFrom = Math.floor((scrollTopPosition - paraTop) / 11.2);
      let checkPosition = 30 - topPosFrom;

      if (topPosFrom > 1) {
        if ($(window).width() >= 1336 && ($(window).width() < 2560)) {
          let topPosFrom = Math.floor((scrollTopPosition - paraTop) / 20);
          $(this).find(".bg-img").css({ objectPosition: `100% ${60 - topPosFrom}%` });
        }
        else if ($(window).width() >= 768 && ($(window).width() < 991)) {
          let topPosFrom = Math.floor((scrollTopPosition - paraTop) / 20);
          $(this).find(".bg-img").css({ objectPosition: `100% ${60 - topPosFrom}%` });
        }

        else if ($(window).width() >= 2560) {
          let topPosFrom = Math.floor((scrollTopPosition - paraTop) / 50);
          $(this).find(".top-img").css({ objectPosition: `100% ${30 - topPosFrom}%` });
        }

        else {
          $(this).find(".bg-img").css({ objectPosition: `100% ${80 - topPosFrom}%` });
        }

        // let topImage = document.querySelector('.bg-img');

      }


    })
  })
}

